/* ============================================
   CUSTOM JS - Fidget Drifters
   Countdown, FAQ, Mobile Nav, Smooth Scroll
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Countdown Timer ---------- */
  const countdown = document.getElementById('announcement-countdown');
  if (countdown) {
    const endDate = new Date(countdown.dataset.endDate + 'T23:59:59').getTime();

    function updateCountdown() {
      const now = Date.now();
      const diff = endDate - now;

      if (diff <= 0) {
        countdown.style.display = 'none';
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ---------- FAQ Accordion ---------- */
  const faqToggles = document.querySelectorAll('[data-faq-toggle]');
  faqToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const item = this.closest('.faq__item');
      const isActive = item.classList.contains('active');

      // Close all other items
      document.querySelectorAll('.faq__item.active').forEach(function (openItem) {
        openItem.classList.remove('active');
        openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
      });

      // Toggle current item
      if (!isActive) {
        item.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Mobile Navigation ---------- */
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileOverlay = document.getElementById('mobile-overlay');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.contains('open');

      mobileNav.classList.toggle('open');
      mobileToggle.classList.toggle('active');
      if (mobileOverlay) mobileOverlay.classList.toggle('active');

      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        mobileToggle.classList.remove('active');
        mobileOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close mobile nav on link click
    mobileNav.querySelectorAll('.header__nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        mobileToggle.classList.remove('active');
        if (mobileOverlay) mobileOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Sticky Header: shadow + auto-hide on scroll down ---------- */
  const header = document.getElementById('site-header');
  if (header) {
    // Don't react to sub-pixel/inertial jitter — only a deliberate move flips it.
    var HIDE_DELTA = 6;
    // Above this the header always shows, so the top of the page never opens
    // with a hidden header (and a short bounce-scroll can't strand it).
    var ALWAYS_SHOW_ABOVE = 120;
    var lastY = window.scrollY;
    var ticking = false;

    function onScrollFrame() {
      ticking = false;
      var y = window.scrollY;
      if (y < 0) y = 0; // iOS rubber-band overscroll

      if (y > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      // Never hide while the mobile nav is open — you'd yank the close button away.
      var navOpen = document.querySelector('.header__nav.open');
      var diff = y - lastY;

      if (y <= ALWAYS_SHOW_ABOVE || navOpen) {
        header.classList.remove('header--hidden');
      } else if (diff > HIDE_DELTA) {
        header.classList.add('header--hidden');
      } else if (diff < -HIDE_DELTA) {
        header.classList.remove('header--hidden');
      }

      if (Math.abs(diff) > HIDE_DELTA) lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScrollFrame);
      }
    }, { passive: true });
  }

  /* ---------- Smooth Scroll for Anchor Links ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;

      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var headerHeight = header ? header.offsetHeight : 0;
        var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  /* ---------- Scroll Reveal Animation ---------- */
  if ('IntersectionObserver' in window) {
    var revealElements = document.querySelectorAll(
      '.how-it-works__step, .testimonial-card, .product-features__item, .why-card, .faq__item'
    );

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  /* ---- Disable right-click save on media ---- */
  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault();
  });
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault();
  });

  /* Keep the reviews CTA present when an A/B variation replaces the carousel. */
  function ensureReviewsArchiveLink() {
    var reviews = document.getElementById('rvw-reviews');
    if (!reviews || reviews.querySelector('.rvw__all-link')) return;

    var wrap = document.createElement('div');
    var link = document.createElement('a');
    wrap.className = 'rvw__all';
    link.className = 'rvw__all-link';
    link.href = '/pages/reviews';
    link.textContent = 'Read all reviews';
    wrap.appendChild(link);
    reviews.appendChild(wrap);
  }

  ensureReviewsArchiveLink();
  var reviewsArchiveObserver = new MutationObserver(ensureReviewsArchiveLink);
  reviewsArchiveObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    ensureReviewsArchiveLink();
    reviewsArchiveObserver.disconnect();
  }, 10000);

});
